(function() {
    'use strict';

    angular.module('tags', [
            'ui.router',

            'tags.constants',
            'tags.services'
        ])
        .config(uiRouting);

    uiRouting.$inject = [
        '$stateProvider',
        'userPermissionsConst',
        'tagsPermissionsConst'
    ];

    function uiRouting($stateProvider, userPermissionsConst, tagsPermissionsConst) {

        $stateProvider
            .state('layout.tags', {
                abstract: true,
                url: '/tags',
                data: {
                    title: 'Tagi',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.tags.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/tags/views/tag-list/tag-list.html',
                        controller: 'TagListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: tagsPermissionsConst.view
                }
            })
            .state('layout.tags.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/tags/views/tag-create/tag-create.html',
                        controller: 'TagCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: tagsPermissionsConst.add
                }
            })
            .state('layout.tags.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/tags/views/tag-update/tag-update.html',
                        controller: 'TagUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: tagsPermissionsConst.update
                }
            });
    }
})();
